import css from 'styled-jsx/css'
import { sizes } from '../../theme'

export default css`
  .video {
    width: 100%;
  }
`
